/* Tables cell sizes are of relative widths, based on the layout and how many columns there are */
/* To ensure we have the sync between two headers - one sticky, one original, we need to compare sizes one by one */
export const syncStickyHeaderScroll = (scrollLeft: number, stickyHeader: HTMLDivElement | null) => {
  if (!stickyHeader) {
    return
  }

  const stickyThead = stickyHeader.querySelector('thead')

  if (stickyThead) {
    const rows = stickyThead.querySelectorAll('tr')

    for (const [rowIndex, row] of rows.entries()) {
      const cells = row.querySelectorAll('th')

      for (const [cellIndex, cell] of cells.entries()) {
        const cellElement = cell as HTMLElement

        const isFirstCellOfFirstRow = rowIndex === 0 && cellIndex === 0

        if (isFirstCellOfFirstRow) {
          cellElement.style.transform = 'translateX(0px)'
          cellElement.style.position = 'sticky'
          cellElement.style.left = '0px'
          cellElement.style.zIndex = '2'
        } else {
          cellElement.style.transform = `translateX(-${scrollLeft}px)`
        }
      }
    }
  }
}
